import React from "react";
import "./Logo.css";

const LogoBottom = ({ name }) => {
  return <h2 className="logo-bottom">{name}</h2>;
};

export default LogoBottom;
